import { GridApi, IRowNode } from 'ag-grid-community';
import { cloneDeep } from 'lodash-es';

class GridApiService {
  private gridApi: GridApi | null = null;

  setGridApi(api: GridApi): void {
    this.gridApi = api;
  }

  getGridApi(): GridApi | null {
    return this.gridApi;
  }
}
export const configForInitialsColumn = {
  width: 80,
  minWidth: 80,
  flex: 0,
};

export const gridApiService = new GridApiService();

export function getSortSelector(allowThreeGroups: boolean = false) {
  const gridApi = gridApiService.getGridApi();
  if (!gridApi) {
    return { sorting: [] };
  }
  const columns = gridApi.getAllGridColumns();
  const rowGroupColumns = gridApi.getRowGroupColumns();

  const sortedColumns = columns
    .filter((column) => !!column.getSort())
    .sort((a, b) => a.getSortIndex() - b.getSortIndex());

  const mode = gridApi.getGridOption('groupDisplayType');
  if (mode === 'singleColumn') {
    const groupColumnsIndex = sortedColumns.findIndex((column) => {
      return column.getColDef()?.showRowGroup;
    });
    // group columns sorting is not set.
    if (groupColumnsIndex > -1) {
      const groupSort = sortedColumns[groupColumnsIndex].getSort();
      const clonedRowGroupColumns = cloneDeep(rowGroupColumns);
      clonedRowGroupColumns.forEach((item) => {
        gridApi.applyColumnState({
          state: [{ sort: groupSort, colId: item.getColId() }],
        });
      });
      sortedColumns.splice(groupColumnsIndex, 1, ...clonedRowGroupColumns);
    }
  }
  const sorting = sortedColumns.map((column) => {
    return {
      // when there are multiple columns with the same field, the showGroup of grouped row will be like this: showGroup_1, showGroup_2, etc. please refer to AnticipatedPaymentsReport
      // we need to remove the _1, _2, etc.
      Key:
        (column?.getColDef()?.showRowGroup as string)?.replace(/_\d+$/, '') || column?.getUserProvidedColDef()?.field,
      Descending: column?.getSort() === 'desc' ? true : false,
    };
  });

  const extraParams = {};

  const hasSumTypeAggColumns = sortedColumns.some((column) => column.getColDef()?.aggFunc === 'sum');

  const groups =
    rowGroupColumns
      .map((column) => {
        return {
          // @ts-ignore
          Key: column?.getUserProvidedColDef()?.groupingKeyForBackend || column?.getUserProvidedColDef()?.field,
        };
      })
      ?.filter((item) => item.Key !== 'DoNotPassGroupingKeyToBackend') || [];
  if (groups.length && sorting.length && hasSumTypeAggColumns) {
    Object.assign(extraParams, {
      // only the last 2 levels of groups are used for sorting
      groups: allowThreeGroups ? groups : groups.slice(-2),
      aggregations: groups.length > 2 ? sorting.slice(1) : sorting,
      sorting: groups.length > 2 ? sorting.slice(1) : sorting,
    });
  }
  return {
    sorting,
    ...extraParams,
  };
}

export const getFirstChildrenValue = (node: IRowNode, key: string) => {
  if (!node || !node.childrenAfterSort?.length) {
    return null;
  }
  if (node.childrenAfterSort?.length) {
    if (node.childrenAfterSort[0]?.data) {
      return node.childrenAfterSort[0]?.data[key];
    } else {
      return getFirstChildrenValue(node.childrenAfterSort[0], key);
    }
  }
};
